import {Trans} from "@lingui/react/macro";

import {doNotTranslateYet} from "@repo/i18n";

export const stepLabel = (step: number) => doNotTranslateYet`Step ${step}`;

export const renameFile = (filename: string) =>
    doNotTranslateYet`Rename ${filename}`;
export const deleteFile = (filename: string) =>
    doNotTranslateYet`Delete ${filename}`;

export const maxFilesPerProgram = (fileCountLimit: number) =>
    doNotTranslateYet`Maximum ${fileCountLimit} files per program.`;

export const renameFileInputLabel = (filename: string) =>
    doNotTranslateYet`New name for ${filename}`;

export const renameAborted = (filename: string) =>
    doNotTranslateYet`Renaming ${filename} aborted`;
export const fileRenamed = (oldFilename: string, newFilename: string) =>
    doNotTranslateYet`Renamed ${oldFilename} to ${newFilename}`;
export const fileCreated = (filename: string) =>
    doNotTranslateYet`Created ${filename}`;
export const fileDeleted = (filename: string) =>
    doNotTranslateYet`Deleted ${filename}`;

export const manageFile = (filename: string) =>
    doNotTranslateYet`Manage ${filename}`;

export const createdByAndLastUpdated = (
    nickname: React.ReactNode,
    timeAgo: React.ReactNode,
) => (
    <Trans
        context={
            'this lists the author of a user-created computer program and how long ago it was most recently updated. The "nickname" placeholder will be replaced by a user\'s self-selected name. The "timeAgo" placeholder will be replaced by text in a format similar to "2 days ago". An example: "Created by: Tim (Updated 2 days ago)"'
        }
    >
        Created by: {nickname} (Updated {timeAgo})
    </Trans>
);
export const basedOn = (link: React.ReactNode) => (
    <Trans context='this describes the relationship between two computer programs. One program is based on another one if it started as a duplicate of an existing program and was then developed further. The "origin" placeholder will be replaced with the title of the program that the current one is based on, and that title will be a clickable link. An example: "Based on: Challenge: Coupon codes".'>
        Based on: {link}
    </Trans>
);
